import React from 'react'

import Logo from '../logo/logo'
import Navigation from '../navigation/navigation'

import styles from './header.module.css'

const Header = props => {
  return (
    <header className={styles.header}>
      <Logo />
      <Navigation items={props.navigation} />
    </header>
  )
}

export default Header
